import React from "react";

import { css } from "@emotion/css";

const Hero = ({ post }) => {
  const style = {
    hero: css({
      width: "100%",
      position: "relative",

      span: {
        position: "absolute",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top center",
        backgroundSize: "cover",
        backgroundImage: `url(${post?.fields?.image?.fields?.file?.url})`,
        filter: "blur(50px)",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
      },

      img: {
        position: "relative",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        zIndex: 1,
        maxWidth: 1446,
        width: "100%",
        height: "auto",
      },
    }),
  };

  return (
    <div style={{ position: "relative", overflow: "hidden" }}>
      <div className={style.hero}>
        <span />
        <img src={post?.fields?.image?.fields?.file?.url} alt="" />
      </div>
    </div>
  );
};

export default Hero;
